import { render, staticRenderFns } from "./BudgetChartDonut.vue?vue&type=template&id=72928af8&"
import script from "./BudgetChartDonut.vue?vue&type=script&lang=js&"
export * from "./BudgetChartDonut.vue?vue&type=script&lang=js&"
import style0 from "./BudgetChartDonut.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports